window.events = new Vue();

window.flash = function(message) {
  window.events.$emit("flash", message);
};

window.confirmation = function(successUrl) {
  window.events.$emit("confirmation", successUrl);
};

window.rowaction = function(data) {
  window.events.$emit("rowaction", data);
};

window.sharedPlans = function(value) {
    window.events.$emit("sharedPlans", value);
};

window.sharedSurveys = function() {
    window.events.$emit("sharedSurveys");
};


window.closeShare = function() {
    window.events.$emit("closeShare");
};
